import React from 'react';
import { useApp } from '../../context/AppContext';
import { FileText, AlertCircle } from 'lucide-react';

const LegalViewer = ({ docId }) => {
    const { legalDocs } = useApp();
    
    // Find doc by ID (case-insensitive)
    const doc = legalDocs.find(d => d.title.toLowerCase().includes(docId.toLowerCase()) || d.id === docId);

    // Fallback titles based on ID
    const titles = {
        'privacy': 'Privacy Policy',
        'terms': 'Terms & Conditions',
        'refund': 'Refund Policy',
        'disclaimer': 'Income Disclaimer'
    };

    return (
        <div className="pt-24 pb-16 min-h-screen bg-gray-50">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                    <div className="p-8 border-b border-gray-100 bg-gray-50/50">
                        <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
                            <FileText className="w-8 h-8 text-primary-600" />
                            {doc?.title || titles[docId] || 'Legal Document'}
                        </h1>
                        <p className="text-gray-500 mt-2 text-sm">
                            Last Updated: {doc?.lastUpdated ? new Date(doc.lastUpdated).toLocaleDateString() : new Date().toLocaleDateString()}
                        </p>
                    </div>

                    <div className="p-8 md:p-12">
                        {doc ? (
                            <div className="prose prose-indigo max-w-none text-gray-600 leading-relaxed whitespace-pre-wrap">
                                {doc.content}
                            </div>
                        ) : (
                            <div className="text-center py-12">
                                <div className="w-16 h-16 bg-yellow-50 rounded-full flex items-center justify-center mx-auto mb-4 text-yellow-500">
                                    <AlertCircle className="w-8 h-8" />
                                </div>
                                <h3 className="text-lg font-bold text-gray-900 mb-2">Content Coming Soon</h3>
                                <p className="text-gray-500 max-w-md mx-auto">
                                    The content for this section contains legal information that is currently being drafted by our administration team. Please check back later.
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LegalViewer;
